import _assign from 'lodash/assign';
import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';
import { setOffsetTime } from '../utils/utils';

export default (state = initialState.appStatus, action) => {
  switch (action.type) {
    case `${ActionTypes.SET_ATTEMPTS_COUNT}_SUCCESS`: {
      const newAttemptedProblems = _assign(
        {},
        state.attemptedProblems,
        action.problems
      );
      return _assign({}, state, { attemptedProblems: newAttemptedProblems });
    }
    case `${ActionTypes.GET_BOOKMARKS}_SUCCESS`:
      return _assign({}, state, { bookmarks: action.payload });
    case `${ActionTypes.SET_BOOKMARK}_SUCCESS`:
      return _assign({}, state, { bookmarks: action.payload });
    case ActionTypes.SHOW_TOAST:
      return _assign({}, state, {
        toast: {
          type: action.toastType,
          show: true,
          message: action.message,
          apiErrorInfo: action.apiErrorInfo,
        },
      });
    case ActionTypes.HIDE_TOAST:
      return _assign({}, state, {
        toast: {
          type: '',
          show: false,
          message: action.message,
          apiErrorInfo: null,
        },
      });
    case ActionTypes.SHOW_SYSTEM_CHECK:
      return _assign({}, state, {
        showSystemCheck: true,
      });
    case ActionTypes.HIDE_SYSTEM_CHECK:
      return _assign({}, state, {
        showSystemCheck: false,
      });
    case `${ActionTypes.GET_SERVER_TIME_AND_TRACKING_ID}_SUCCESS`: {
      const {
        isSystemTimeMismatchEnabled,
        isInitialCall,
        autoSubmitReason,
      } = action.payload;
      if (isSystemTimeMismatchEnabled || isInitialCall)
        setOffsetTime(action.payload?.offsetTime);
      const { serverTime } = state;
      if (serverTime && isInitialCall) return state;
      const updatedState = {
        ...state,
        serverTime: action.payload?.serverTime,
        offsetTime: action.payload?.offsetTime,
      };
      if (autoSubmitReason) {
        updatedState.autoSubmitReason = autoSubmitReason;
      }
      if (isInitialCall)
        updatedState.intercomIds = {
          intercomUserHash: action.payload?.intercomUserHash,
          intercomRecruiterAppId:
            process.env.REACT_APP_INTERCOM_RECRUITER_APP_ID,
          intercomHackerAppId: process.env.REACT_APP_INTERCOM_HACKER_APP_ID,
        };
      if (serverTime && !isInitialCall && isSystemTimeMismatchEnabled) {
        updatedState.isSystemTimeMismatch =
          action.payload?.isSystemTimeMismatch;
      }
      return updatedState;
    }
    case ActionTypes.SHOW_REPORT_ISSUE:
      return _assign({}, state, { reportIssueData: action.payload });
    case ActionTypes.HIDE_REPORT_ISSUE:
      return _assign({}, state, { reportIssueData: null });
    case ActionTypes.SHOW_PREPARING_ASSESSMENT_MODAL:
      return _assign({}, state, { showPreparingAssessmentModal: true });
    case ActionTypes.HIDE_PREPARING_ASSESSMENT_MODAL:
      return _assign({}, state, { showPreparingAssessmentModal: false });
    case ActionTypes.ENABLE_SINGLE_PROBLEM_VIEW:
      return _assign({}, state, {
        isSingleProblemView: true,
      });
    case ActionTypes.DISABLE_SINGLE_PROBLEM_VIEW:
      return _assign({}, state, {
        isSingleProblemView: false,
      });
    case ActionTypes.SET_SAVE_IN_PROGRESS:
      if (action.problemSlug) {
        const saveInProgress = _assign({}, state.saveInProgress, {
          [action.problemSlug]: action.isInProgress,
        });
        return _assign({}, state, {
          saveInProgress,
        });
      }
      return state;
    case `${ActionTypes.CHECK_URL_FOR_IFRAME}_SUCCESS`:
      return _assign({}, state, {
        openIframeInModal: { success: true, url: action.url },
      });
    case `${ActionTypes.CHECK_URL_FOR_IFRAME}_FAIL`:
      return _assign({}, state, {
        openIframeInModal: { success: false, url: action.url },
      });
    case ActionTypes.CLEAR_URL_FOR_IFRAME_DATA:
      return _assign({}, state, {
        openIframeInModal: { success: null, url: null },
      });
    case `${ActionTypes.CLEAR_SOLUTION}_SUCCESS`: {
      const { problemSlug, clusterSlug } = action;
      const newAttemptedProblems = _assign({}, state.attemptedProblems);
      if (clusterSlug) delete newAttemptedProblems[clusterSlug];
      if (problemSlug) delete newAttemptedProblems[problemSlug];
      return _assign({}, state, { attemptedProblems: newAttemptedProblems });
    }
    case ActionTypes.APP_ONLINE:
      return _assign({}, state, {
        isOffline: false,
      });
    case ActionTypes.APP_OFFLINE:
      return _assign({}, state, {
        isOffline: true,
      });
    case ActionTypes.SHOW_AUTO_SUBMIT_MODAL:
      return { ...state, showAutoSubmitModal: true };
    case ActionTypes.HIDE_AUTO_SUBMIT_MODAL:
      return { ...state, showAutoSubmitModal: false };
    case ActionTypes.SET_AUTO_SUBMIT_REASON:
      return { ...state, autoSubmitReason: action.reason };
    case ActionTypes.SET_TIMER_EXPIRED:
      return { ...state, isTimerExpired: action.isExpired };
    default:
      return state;
  }
};
